<template>
    <div>
        <div v-for="item, idx in internal" :key="idx" class="author-wrapper">
            <div class="field-container author-head">
                <span v-if="idx !==0">Author #{{idx+1}}</span>
                <span v-else>Presenting Author</span>
                <a href="#" @click.prevent="internal.splice(idx,1)" v-if="idx !== 0">Remove author</a>
            </div>
            <div class="field-container">
                <span>First Name: *</span>
                <div><input type="text" v-model="internal[idx][0]" /></div>
            </div>
            <div class="field-container">
                <span>Preposition: (e.g. de, van)</span>
                <div><input type="text" v-model="internal[idx][1]" /></div>
            </div>
            <div class="field-container">
                <span>Last Name: *</span>
                <div><input type="text" v-model="internal[idx][2]" /></div>
            </div>
            <div class="field-container">
                <span>Affiliation: *</span>
                <div><input type="text" v-model="internal[idx][3]" /></div>
            </div>
        </div>
        <br>
        <button @click="internal.push([null,null,null,null])" :disabled="internal.length>=field.maxitems">Add author</button>
    </div>
</template>

<script>
    export default {
        name: 'v-author-field',
        props:['value', 'field'],
        data(){
            return{
                'internal':[[null,null,null,null]],
            }
        },
        watch:{
            'internal':{
                handler(){ this.$emit('input', this.internal) }
            }
        }
    }
</script>

<style scoped lang="scss">
    .author-head{
        font-weight: bold;
        a{
            color:red;
        }
    }

    .author-wrapper{
        margin:20px 0;
    }

    .field-container{
        display:flex;
        span{ width:220px;}
        div > input{ width:100% }
    }
</style>
